import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const put = (id,user) =>
  requestsTemplates.put(mainPath, `/users/${id}`,user);
